import { useId, type ReactNode } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";

export interface CollapsibleSectionProps {
  title: string;
  subtitle?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  /** Etiqueta accesible del botón según el estado actual. */
  toggleLabel: (open: boolean) => string;
}

/** Sección de pantalla con título, subtítulo y botón de 36px para contraerla. El contenido se oculta, no se destruye. */
export function CollapsibleSection({ title, subtitle, open, onOpenChange, children, toggleLabel }: CollapsibleSectionProps) {
  const contentId = useId();
  const Chevron = open ? FiChevronDown : FiChevronRight;

  return (
    <section className="flex flex-col">
      <div className="mb-4 flex items-start justify-between gap-4">
        <div>
          <h2 className="m-0 text-[20px] font-medium leading-6 tracking-[-0.01em] text-[var(--ds-ink)]">{title}</h2>
          {subtitle && <p className="m-0 mt-1 text-sm leading-5 text-[var(--ds-ink-muted)]">{subtitle}</p>}
        </div>
        <button
          type="button"
          aria-label={toggleLabel(open)}
          aria-expanded={open}
          aria-controls={contentId}
          onClick={() => onOpenChange(!open)}
          className="flex h-9 w-9 flex-none items-center justify-center rounded-full border-[1.5px] border-solid border-[var(--ds-ink)] bg-transparent text-[var(--ds-ink)] hover:bg-[var(--app-row-hover-bg)]"
        >
          <Chevron aria-hidden="true" className="h-4 w-4" />
        </button>
      </div>
      <div id={contentId} hidden={!open}>
        {children}
      </div>
    </section>
  );
}
